
import {  Component, Prop, Watch } from 'vue-property-decorator'
import { ALLOWED_EXTENSIONS } from '../helpers/constants'
import Mixin from '../helpers/mixin'

@Component({
  template: `
      <div class="upload">
      <input ref="fileInput" type="file" :multiple="multipleFiles" @change="handleUpload" :accept="allowedExtensions" @click="$refs.fileInput.value=null" />
        <div class="flex flex-align-center">
          <button class="select-file" @click="triggerFileUpload">
              <i class="icons8-attach"></i>
              <div class="label">{{ toggleTitle }}</div>
          </button>
          <i v-if='tooltipText' class="icons8-info ml-025" v-tooltip="{ placement: this.isPhone ? 'top' : 'right', content: tooltipText, trigger: 'hover click' }"></i>
        </div>
        <div class="file-name flex" v-for="(val, index) in currentFiles">
            <div class="file-name__ellipsis"> {{ val.name }}</div><i class="icons8-delete file-name__icon" @click.stop="deleteFile(index)"></i>
        </div>
        <transition-expand>
            <div class="error-message" v-if="showExtensionError">{{ 'formErrorWrongFileExtension' | t }}</div>
        </transition-expand>
        <transition-expand>
            <div class="error-message" v-if="showMaxFileSizeError">{{ 'formErrorFileSizeTooBig' | t }} {{ maxFileSizeInMb }} MB</div>
        </transition-expand>
    </div>
    `
})
export default class Uploadfield extends Mixin {
  @Prop({ default: '' }) label: string
  @Prop({ default: '' }) placeholderAddText: string
  @Prop({ default: '' }) placeholderEditText: string
  @Prop({ default: '' }) tooltipText: string
  @Prop() error: boolean
  @Prop({ default: false }) multipleFiles: boolean
  @Prop({ default: 15 }) maxFileSizeInMb: number

  @Prop() value: any [] | any
  currentFiles: any [] = [];
  showExtensionError = false;
  showMaxFileSizeError = false;

  allowedExtensions = ALLOWED_EXTENSIONS

  handleUpload(items: any) {
    const files = items.target.files || items.dataTransfer.files;
    if (!files) return

    if(this.multipleFiles)  {
      this.createFiles(files);
    }
    else {
      this.$emit("input", files[0])
      this.currentFiles = [...files[0]];
    }

  }

  createFiles(files: any) {
    //Concat not working for Filelist
    for (let index = 0; index < files.length; index++) {
      this.currentFiles.push(files[index]);
    }

    this.$emit("input", this.currentFiles)
  }

  deleteFile(index: any) {
    this.currentFiles.splice(index,1);
    this.$emit("input", this.currentFiles.length === 0 ? null : this.currentFiles)
  }

  triggerFileUpload(): void {
    (this.$refs.fileInput as HTMLInputElement).click()
  }

  get toggleTitle(): string {
    return this.value && this.placeholderEditText ? this.placeholderEditText : this.placeholderAddText
  }

  loadValues() {
    if(this.value) {
      this.currentFiles = [...this.value]

    }
  }

  created() {
    this.$nextTick(() => this.loadValues() )
  }

  @Watch('currentFiles')
  checkErrors(currentFiles: any[]) {
    this.showExtensionError = false
    this.showMaxFileSizeError = false
    for(let i=0; i < currentFiles.length; i++){
      const currentFile = currentFiles[i]
      const extension: string = currentFile.name.split('.').pop()

      if( !this.allowedExtensions.includes(`.${extension.toLowerCase()}`)) {
        this.showExtensionError = true
      }
      if(currentFile.size / 1024 / 1024 > this.maxFileSizeInMb) this.showMaxFileSizeError = true
    }
  }

}
